 <template>
  <v-form ref="pto_form" lazy-validation>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          class="mt-2 ml-2 mb-2 mr-0 ptoBtn"
          color="#FFB500"
          depressed
          @click="activate_scroll()"
        >
          <v-icon class="pr-2">mdi-pencil</v-icon>&nbsp;View/Edit
        </v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark class="ptoClose" @click="closeChangeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Scheduled Dates</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="submitPtoChange" class="dk_brown"> Save </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-container class="ml-5 mt-0 mb-0 pt-0 pb-0">
          <v-row>
            <v-col cols="12" class="note">
              To make changes to NYPFL and Disability dates, please contact HR.
            </v-col>
          </v-row>
        </v-container>

        <v-container class="ml-10 mt-0 mb-0 pt-0 pb-0">
                 <v-row>
        <v-col
          :class="{
            custom1cols: $vuetify.breakpoint.xs,
            custom3cols: $vuetify.breakpoint.smAndUp,
          }"
        >
          <v-subheader class="pl-0 prompt">I work on weekends</v-subheader>
        </v-col>
        <v-col class="pto_align_center" 
          :class="{
            custom1cols: $vuetify.breakpoint.xs,
            custom3cols: $vuetify.breakpoint.smAndUp,
          }"
        >
          <v-switch
            v-model="work_weekends"
            aria-label="I work on weekends"
          ></v-switch>
        </v-col>
        <v-col
          :class="{
            custom1cols: $vuetify.breakpoint.xs,
            hidden: $vuetify.breakpoint.smAndUp,
          }"
        >
        </v-col>
      </v-row>
        </v-container>

        <!-- Sched Days Loop -->
        <v-container
          class="ml-10 mt-0 mb-0 pt-0 pb-0"
          v-for="(sched_pto, h) in scheduled_pto"
          :key="h"
        >
        <v-row v-if="sched_pto.show_fy_header == true">
            <v-col cols="12" class="fy_header" :id="sched_pto.header_id" >{{
              sched_pto.fy_str
            }}</v-col>
        </v-row> 

        <div v-for="(p, i) in sched_pto" :key="i">
          <v-row v-if="p.scheduled_info_array.length > 0  && p.scheduled_info_array.length > p.scheduled_NYPFL_DIS_array.length ">
            <v-col cols="12" class="font-weight-medium">{{
              p.name_plural 
            }}</v-col>
          </v-row>
          <v-row v-if="p.scheduled_info_array.length > 0">
            <v-col cols="12" class="pl-0 pt-0">
              <div v-for="(sched, j) in p.scheduled_info_array" :key="j" >
                <v-row v-if="p.scheduled_status_array[j] != 'Confirmed'">
                  <v-col cols="3">                    
                         <v-tooltip left v-if="p.scheduled_status_array[j]">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="
                                p.scheduled_status_array[j] == 'Confirmed'
                              "
                              class="icon-circle-green"
                              aria-label="Employee Confirmed"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-check-circle</v-icon
                            >
                            <v-icon
                              v-else-if="
                                p.scheduled_status_array[j] == 'Approved'
                              "
                              class="icon-circle-gray icon-white"
                              aria-label="Pending Employee Confirmation"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-timer-sand</v-icon
                            >
                            <v-icon
                              v-else
                              class="icon-circle-gray icon-white"
                              aria-label="Pending Manager Approval"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-timer-sand</v-icon
                            >
                          </template>
                          <span
                            v-if="p.scheduled_status_array[j] == 'Confirmed'"
                            >Employee Confirmed</span
                          >
                          <span
                            v-else-if="
                              p.scheduled_status_array[j] == 'Approved'
                            "
                            >Pending Employee Confirmation</span
                          >
                          <span v-else>Pending Manager Approval</span>
                        </v-tooltip>                  
                    {{ sched }} 
                  </v-col>
                  <v-col cols="9">
                      <v-btn
                        value="edit"
                        v-bind:data="p.scheduled_ids[j]"
                        v-bind:id="p.scheduled_ids[j] + '_edit'"
                        v-bind:fy="h"
                        v-bind:cat="i"
                        v-bind:pos="j"
                        class="subtitle-2"
                        @click="editPto"
                        :sync="true"
                      >
                        <v-icon class="pr-2">mdi-pencil</v-icon>Edit
                      </v-btn>
                      <v-btn
                        value="delete"
                        v-bind:data="p.scheduled_ids[j]"
                        v-bind:id="p.scheduled_ids[j] + '_delete'"
                        class="subtitle-2"
                        @click="editPto"
                      >
                        <v-icon class="pr-2">mdi-delete</v-icon>Delete
                      </v-btn>
                    <br />
                  </v-col>
                </v-row>

                <div class="form-group" v-for="(input, k) in inputs" :key="k">
                  <div
                    v-if="input.sched_id == p.scheduled_ids[j]"
                    v-bind:id="p.scheduled_ids[j]"
                    class="p_sched_ids"
                    style="display: none"
                  >
                    <v-row
                      :class="{
                        dateBlockMobile: $vuetify.breakpoint.xs,
                        dateBlock: $vuetify.breakpoint.smAndUp,
                      }"
                    >
                      <v-col
                        :class="{
                          custom1cols: $vuetify.breakpoint.xs,
                          custom3cols: $vuetify.breakpoint.smAndUp,
                        }"
                      >
                        <v-subheader class="pl-0 prompt">New Date </v-subheader>
                      </v-col>
                      <v-col
                        :class="{
                          changeCustom1cols: $vuetify.breakpoint.xs,
                          custom9cols: $vuetify.breakpoint.smAndUp,
                        }"
                      >
                        <v-menu
                          v-model="input['new_menu']"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="input['new_day']"
                              aria-label="Select New Date"
                              append-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              outlined
                              single-line
                              dense
                              required
                              :rules="newDateRules"
                              class="messages"
                              @click="populate_default(k)"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="input['new_day']"
                            :allowed-dates="allowedDates"
                            :min="date_picker_min"
                            :max="date_picker_max"
                            no-title
                            color="#4f2c1d"
                            class="dt-picker"
                            @input="input['new_menu'] = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>

                    <v-row
                      :class="{
                        dateBlockMobile: $vuetify.breakpoint.xs,
                        dateBlock: $vuetify.breakpoint.smAndUp,
                      }"
                    >
                      <v-col
                        :class="{
                          custom1cols: $vuetify.breakpoint.xs,
                          custom3cols: $vuetify.breakpoint.smAndUp,
                        }"
                      >
                        <v-subheader class="pl-0 prompt"
                          >Type of PTO</v-subheader
                        >
                      </v-col>
                      <v-col
                        :class="{
                          changeCustom1cols: $vuetify.breakpoint.xs,
                          custom9cols: $vuetify.breakpoint.smAndUp,
                        }"
                      >
                        <v-select
                          v-model="input['type']"
                          :rules="typeRules"
                          :items="pto_types"
                          item-value="id"
                          item-text="name"
                          aria-label="PTO Type"
                          class="messages"
                          outlined
                          single-line
                          dense
                          required
                          :menu-props="{maxHeight: '350'}"
                        />
                        <div v-if="input.type == 'sick'" >
              <p class="inst">
                <ul>
                 <li>Please note a doctor's note is required to return to work if you take 5+ consecutive sick days for employees' own personal use.</li>
                 <li>For clarity on the allotted number of days for covid please visit the: <a href="https://www.adelphi.edu/policies/covid-19-leave/" target="_blank" class="bold-link">https://www.adelphi.edu/policies/covid-19-leave/</a></li>
                </ul>
              </p>
             </div>
             <div v-else-if="input.type == 'jury_duty'" >
              <p class="inst">For details, please visit <a href="https://www.adelphi.edu/hr/benefits/jury-duty/" target="_blank" class="bold-link">Time off for Jury Duty</a></p>
             </div>
             <div v-else-if="input.type == 'bereavement'" >
              <p class="inst">For clarity on the allotted number of days for bereavement please visit the <a href="https://www.adelphi.edu/policies/bereavement/" target="_blank" class="bold-link">Bereavement Leave Policy</a> page.</p>
             </div>
             <div v-else-if="input.type == 'covid'" >
              <p class="inst">
               <ul>
                 <li>For details, please visit "Vaccine Requirements and FAQs for Faculty, Staff and Administration" section on <a href="https://www.adelphi.edu/coronavirus/health-wellness-safety/vaccination-information/" target="_blank" class="bold-link">Vaccine Information</a> page.</li>
                 <li>Per New York state law, all Adelphi employees are entitled to four (4) hours of paid time off per COVID-19 vaccine injection. You can read more about it on <a href="https://dol.ny.gov/system/files/documents/2021/10/cd6-paid-leave-for-covid19-vaccinations-10-12-21_0.pdf" target="_blank" class="bold-link">the NYS website</a>.</li>
                 <li>You should notify your manager of scheduled appointments in advance and note the time off as “½ CV” (Covid Vaccine) on your time cards/sheets.</li>
                </ul>
              </p>
             </div>
            <div v-if="input.type == 'covid_sick'" >
              <p class="inst">
                For clarity on the allotted number of days for covid please visit the: <a href="https://www.adelphi.edu/policies/covid-19-leave/" target="_blank" class="bold-link">https://www.adelphi.edu/policies/covid-19-leave/</a></p>
             </div>   
             <div v-else-if="input.type == 'prenatal'" >
              <p class="inst">Prenatal Care leave can be used by employees for their own health care services received during their pregnancy or related to such pregnancy, including physical examinations, medical procedures, monitoring and testing, and discussions with a health care provider related to the pregnancy. It can also be used for fertility treatment or care appointments and end-of-pregnancy care appointments. Employees must use this benefit in hourly increments. </p>
             </div>                
             <div v-else >
              <p class="inst">Non-Union employees are entitled to one floating holiday per year for President's Day. This holiday can be used on the date or later.</p>
            </div>
                      </v-col>
                    </v-row>



                    <v-row v-if="input.type == 'prenatal'">
          <v-col
            :class="{
              custom1cols: $vuetify.breakpoint.xs,
              custom3cols: $vuetify.breakpoint.smAndUp,
            }"
          >
            <v-subheader class="pl-0 prompt">Prenatal Care</v-subheader>
          </v-col>
          <v-col
            :class="{
              custom1cols: $vuetify.breakpoint.xs,
              custom6cols: $vuetify.breakpoint.smAndUp,
            }"
          >
              From: <vue-timepicker v-model="input.prenatal_start" format="hh:mm a" minute-interval="30" hide-clear-button auto-scroll fixed-dropdown-button
              ></vue-timepicker>&nbsp;&nbsp;&nbsp;
              To: <vue-timepicker v-model="input.prenatal_end" format="hh:mm a" minute-interval="30" hide-clear-button auto-scroll fixed-dropdown-button
              ></vue-timepicker>
          </v-col>
          <v-col
            :class="{
              custom1cols: $vuetify.breakpoint.xs,
              hidden: $vuetify.breakpoint.smAndUp,
            }"
          >
          </v-col>
        </v-row>        



                    <v-row v-else
                      :class="{
                        dateBlockMobile: $vuetify.breakpoint.xs,
                        dateBlock: $vuetify.breakpoint.smAndUp,
                      }"
                    >
                      <v-col
                        :class="{
                          custom1cols: $vuetify.breakpoint.xs,
                          custom3cols: $vuetify.breakpoint.smAndUp,
                        }"
                      >
                        <v-subheader class="pl-0 prompt"
                          >Full or Partial Days</v-subheader
                        >
                      </v-col>
                      <v-col
                        :class="{
                          custom1cols: $vuetify.breakpoint.xs,
                          custom4cols: $vuetify.breakpoint.smAndUp,
                        }"
                      >
                        <v-radio-group
                          v-model="input['full_partial']"
                          mandatory
                        >
                          <v-radio
                            label="Full Day"
                            value="FULL"
                            class="black--text radio"
                          ></v-radio>
                          <v-radio
                            label="Half Day (Morning)"
                            value="AM"
                            class="black--text radio"
                          ></v-radio>
                          <v-radio
                            label="Half Day (Afternoon)"
                            value="PM"
                            class="black--text radio"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col
                        :class="{
                          custom1cols: $vuetify.breakpoint.xs,
                          hidden: $vuetify.breakpoint.smAndUp,
                        }"
                      >
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          </div>

        </v-container>
        <div class="form_padding">&nbsp;</div>
      </v-card>
    </v-dialog>


        <div class="text-center">
      <v-dialog v-model="dialog2" persistent max-width="350" :retain-focus="false">
        <v-card>
          <v-card-title class="headline">
            {{ dialog2_title }}
          </v-card-title>
          <v-card-text>{{ dialog2_text }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn  v-if="dialog2_redBtn != ''" color="red darken-1" text @click="closeDialog(dialog2_redBtn_type)">
              {{ dialog2_redBtn }}
            </v-btn>             
            <v-btn color="blue darken-1" text @click="closeDialog(dialog2_blueBtn_type)">
              {{ dialog2_blueBtn }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-form>  
</template>
      
      
<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import pto_func from "@/pto_functions";
import axios from "axios";
import moment from 'moment';

export default {

  components: {
    VueTimepicker,
  },

  props: ["pto", "ptoChange_scroll_to"],

  data() {
    return {
      dialog: false,
    dialog2: false,
    dialog2_title: "Alert!",
    dialog2_blueBtn: "OK",
    dialog2_blueBtn_type: "",
    dialog2_text: "",
    dialog2_redBtn: "",
    dialog2_redBtn_type: "",

    date_picker_min: pto_func.get_date_picker_min(),
    date_picker_max: "",
    site_status: pto_func.get_site_status(),
    cur_fiscal_year: pto_func.get_fiscal_year("cur_long"),
    next_fiscal_year: pto_func.get_fiscal_year("next_long"),
    prev_fiscal_year: pto_func.get_fiscal_year("prev_long"),
    scroll: false,
    gender: "",

      pto_cat_codes: [],
      //scheduled_pto: [],
      toggle_exclusive: [],
      toggle_states: [],
      work_weekends: false,

      au_holidays: [],
      inputs: [],
      deletes: [],

      scheduled_pto: pto_func.sched_pto_set_format(),
      pto_container: pto_func.pto_container_set_format(),
      pto_types: [],

      typeRules: [(v) => !!v || "Type of PTO is required"],
      newDateRules: [(v) => !!v || "New Date is required"],
    };
  },

  mounted() { 
    this.gender = this.pto[this.cur_fiscal_year]['gender'] ;
    this.pto_types = pto_func.getPtoCats("object", this.gender) ;

    axios.get("./remote-apis/pto_api.php?cmd=pto_holiday").then((response) => {
      this.saas_holidays = response.data;
      this.au_holidays = pto_func.formatAuHolidays(this.saas_holidays);
      this.date_picker_max = pto_func.get_date_picker_max();
    }).
    catch(error => {
      window.console.error(error);
    });
/*
    onload_scroll_to () {
      window.console.log("scroll to....");
      if (!this.ptoChange_scroll_to)
        return;
      let header_id = "header_" + this.ptoChange_scroll_to;
      window.console.log(header_id);
      if (document.getElementById(header_id) && this.updated) {
        document.getElementById(header_id).scrollIntoView() ;
        window.console.log("here...");
      }
    };
*/
/*
    document.onreadystatechange = () => {
    if (document.readyState == "complete") {
      window.console.log('Page completed with image and files!')
      // fetch to next page or some code
    }
  }*/


  this.pto_cat_codes = pto_func.getPtoCats("codes");
    var tmp_cat = "";
    var fy_has_scheduled = {};

    for (var i = 0; i < this.pto_cat_codes.length; i++) {
      tmp_cat = this.pto_cat_codes[i];

      // looping FY
      for (let entry of Object.entries(this.pto)) {
        let entry_yr = entry[0];

        if (entry_yr.substring(0,2) != "20") {  // firstname and lastname fields
          continue;
        }

        // Once roll data begins, cannot change prev year pto.
        // Adding this just in case SAAS sends us prev year data.
        if ((this.site_status == "roll_data" || this.site_status == "after_data_rolled") && parseInt(entry_yr) == this.prev_fiscal_year) {
          continue;
        }

        if (this.pto[entry_yr][tmp_cat]['remain_total'])
          this.pto_container[entry_yr][tmp_cat]['remain_total'] = this.pto[entry_yr][tmp_cat]['remain_total'];

        if (this.pto[entry_yr][tmp_cat]["taken_dates_array"] && this.pto[entry_yr][tmp_cat]["taken_dates_array"].length > 0) {
          this.pto_container[entry_yr][tmp_cat]['taken_dates_array'] = this.pto[entry_yr][tmp_cat]['taken_dates_array'];
          this.pto_container[entry_yr][tmp_cat]['taken_full_partial_array'] = this.pto[entry_yr][tmp_cat]['taken_full_partial_array'];
        }  

        if (this.pto[entry_yr][tmp_cat]["scheduled_dates_array"] && this.pto[entry_yr][tmp_cat]["scheduled_dates_array"].length > 0) {
          this.toggle_exclusive[i] = [];
          this.pto_container[entry_yr][tmp_cat]['scheduled_dates_array'] = this.pto[entry_yr][tmp_cat]['scheduled_dates_array'];
          this.pto_container[entry_yr][tmp_cat]['scheduled_status_array'] = this.pto[entry_yr][tmp_cat]['scheduled_status_array'] ;

          this.pto_container[entry_yr][tmp_cat]['scheduled_start_time_array'] = [] ;
          this.pto_container[entry_yr][tmp_cat]['scheduled_end_time_array'] = [] ;
          this.pto_container[entry_yr][tmp_cat]['scheduled_full_partial_array'] = [] ;

          let tmp_info = null;
          let tmp_time = null;
          let scheduled_NYPFL_DIS = [];

          for (let x = 0; x < this.pto[entry_yr][tmp_cat]['scheduled_ids'].length; x++) {
            // Prenatal leave is requested by hours, set start and end time here.
            if (tmp_cat == "prenatal") {
              tmp_info = this.pto[entry_yr][tmp_cat]['scheduled_ids'][x].split("_") ;
              tmp_time = tmp_info[2].split("-");
              this.pto_container[entry_yr][tmp_cat]['scheduled_start_time_array'][x] = tmp_time[0] ;
              this.pto_container[entry_yr][tmp_cat]['scheduled_end_time_array'][x] = tmp_time[1] ;
              this.pto_container[entry_yr][tmp_cat]['scheduled_full_partial_array'][x] = "" ;
            } else {
              this.pto_container[entry_yr][tmp_cat]['scheduled_start_time_array'][x] = "" ;
              this.pto_container[entry_yr][tmp_cat]['scheduled_end_time_array'][x] = "" ;
            }

            // put NYPFL and DIS in an array 
            if (pto_func.is_NYPFL(this.pto[entry_yr][tmp_cat]['scheduled_full_partial_array'][x]) || 
                pto_func.is_sched_DIS(this.pto[entry_yr][tmp_cat]['scheduled_full_partial_array'][x], this.pto[entry_yr][tmp_cat]['scheduled_status_array'][x])) {
                  scheduled_NYPFL_DIS.push(this.pto[entry_yr][tmp_cat]['scheduled_ids'][x]) ;
            }

          }

          this.pto[entry_yr][tmp_cat]['scheduled_NYPFL_DIS_array'] = scheduled_NYPFL_DIS ;
          this.pto_container[entry_yr][tmp_cat]['scheduled_NYPFL_DIS_array'] = scheduled_NYPFL_DIS ;
          

          if (tmp_cat != "prenatal") {
            this.pto_container[entry_yr][tmp_cat]['scheduled_full_partial_array'] = this.pto[entry_yr][tmp_cat]['scheduled_full_partial_array'];
          }
          
          this.scheduled_pto[entry_yr].push(this.pto[entry_yr][tmp_cat]);

          fy_has_scheduled[entry_yr] = true;
      
          for (var a = 0; a < this.pto[entry_yr][tmp_cat]["scheduled_ids"].length; a++) {
            // Cannot change/delete NYPFL and DIS 
            if (this.pto[entry_yr][tmp_cat]["scheduled_NYPFL_DIS_array"].length > 0 && this.pto[entry_yr][tmp_cat]["scheduled_NYPFL_DIS_array"].includes(this.pto[entry_yr][tmp_cat]["scheduled_ids"][a]))
              continue;
        
            this.toggle_states.push({
              sched_id: this.pto[entry_yr][tmp_cat]["scheduled_ids"][a],
              value: "",
            });

            this.toggle_exclusive[i][a] = 0;
            this.inputs.push({
              sched_id: this.pto[entry_yr][tmp_cat]["scheduled_ids"][a],
              new_menu: "",
              new_day: "",
              type: "",
              full_partial: "",
              prenatal_start: "12:00 am",
              prenatal_end: "12:00 am"
            });
          }
        }  
      }
    }    

    if (this.site_status != "cur_year_only") {
      let fys = Object.keys(fy_has_scheduled);
      fys.forEach((fy) => {
        if (fy_has_scheduled[fy]) 
          this.scheduled_pto[fy]['show_fy_header'] = true;
      })
    }

  },

  updated: function () {
    if (this.scroll) {
      this.scroll_to_header();
      this.scroll = false;
    }

    // Ticket 535848, a hack to keep the input divs stay expanded. 
    let p_sched_ids = document.getElementsByClassName("p_sched_ids");
    let tmp_id = "" ;
    for (var i = 0; i < p_sched_ids.length; i++) {
      tmp_id = p_sched_ids[i].getAttribute("id") ;
      if (document.getElementById(tmp_id + "_edit") && document.getElementById(tmp_id + "_edit").classList.contains('pto_btn_active')) {
          document.getElementById(tmp_id).style.display = "";
      } else {
          document.getElementById(tmp_id).style.display = "none";
      }
    }

  },

  methods: {

    activate_scroll() {
      // Cannot call scroll_to_header() here, header_xxxx is still null at this point.
      // Set a flag and let updated hook call scroll_to_header() when page finished loading.
      this.scroll = true;
    },

    scroll_to_header () {
      // Next year's edit button is clicked, scroll directly to next year section
      if (!this.ptoChange_scroll_to)
        return;
      let header_id = "header_" + this.ptoChange_scroll_to;
      if (document.getElementById(header_id) && this.scroll) {
        document.getElementById(header_id).scrollIntoView() ;
      }
    },

    format_sched_date(code, sched, idx) {
      var res = new Date(sched + "T09:00:00.000Z");
      res = pto_func.formatDate(res, "long");
      res += " - " + this.pto[code]["scheduled_full_partial"][idx];
      return res;
    },

    closeDialog(clicked) {
      this.dialog2 = false;

      if (clicked == "leave") {
          window.location.reload();
      } else if (clicked == "success") {
         window.location.reload();
        /*
        this.$router.push({
          path: "/pto/balance",
        });*/
      }
    },

    editPto(e) {

      var id = e.currentTarget.getAttribute("id");
      var action = e.currentTarget.value;
      var element = document.getElementById(id);
      var data = e.currentTarget.getAttribute("data");
      var edit_el = document.getElementById(data + "_edit");
      var delete_el = document.getElementById(data + "_delete");
      var isActive = element.classList.contains("pto_btn_active");
      var isEditActive = edit_el.classList.contains("pto_btn_active");
      var fy = e.currentTarget.getAttribute("fy");

      // css stuff
      edit_el.classList.remove("pto_btn_active");
      delete_el.classList.remove("pto_btn_active");
         
      if (
        action == "edit" &&
        document.getElementById(data).style.display == "none"
      ) {

        // Remove original scheduled date, make it becomes available for selection. 
        // Example: changing same date from full to half should not throw error.
        this.pto_container = pto_func.update_pto_container(data, fy, this.pto_container, "array_splice"); 

        // Validate inputs array.
       if (this.validateChanges() == false) {      
        // Validation failed, put info back to pto_container. Undo previous step
        this.pto_container = pto_func.update_pto_container(data, fy, this.pto_container, "array_push"); 
        return;
       }
       
       // Valid request. Add ori data in deletes array.
        /////this.update_deletes(data, "array_push");

        // Show input fields.
        document.getElementById(data).style.display = "";
         element.classList.add("pto_btn_active");
      } else {
        // delete or click edit again
        // reset input fields
        for (var i = 0; i < this.inputs.length; i++) {
              // Reset input fields
              if (this.inputs[i]['sched_id'] == data) {
                this.inputs[i]['new_day'] = "" ;
                this.inputs[i]['type'] = "";
                this.inputs[i]['full_partial'] = "FULL";
                this.inputs[i]['prenatal_start'] = "12:00 am";
                this.inputs[i]['prenatal_end'] = "12:00 am";
                break;
              } 
        }
        if (action == "edit") { // cancel edit, remove from deletes array
          /////this.update_deletes(data, "array_splice");
          this.pto_container = pto_func.update_pto_container(data, fy, this.pto_container, "array_push"); 
        } else { // delete 
          if (isActive) {
            // click delete again to undo
            // remove from deletes
            this.update_deletes(data, "array_splice");
          } else {
            this.update_deletes(data, "array_push");
            element.classList.add("pto_btn_active");
            // Expanded Edit, then click on Delete while it's expanded.
            // Put ori date back to pto_container:
            if (isEditActive) {
              this.pto_container = pto_func.update_pto_container(data, fy, this.pto_container, "array_push"); 
            }
          }       
        }
        // hide input fields
        document.getElementById(data).style.display = "none";
      }

    },

    update_deletes(id, action) {

      for (var i = 0; i < this.deletes.length; i++) {
        if (this.deletes[i] == id) {
          if (action == "array_push") {
            // id is already in deletes[], no action required
            return;
          } else {
            // action == "array_splice"
            this.deletes.splice(i);
            return;
          }
        }
      }
      // Not in deletes[]
      if (action == "array_push") {
        this.deletes.push(id);
      }
      return;
    },

    allowedDates(val) {
      // disable holidays and, if applicable, weekends
      var disallowed = false;
      for (var i = 0; i < this.au_holidays.length; i++) {
        if (this.au_holidays[i] == val) {
          disallowed = true;
          break;
        }
      }

      if (disallowed == false) {
        if (this.work_weekends === false) {
          // emp do not work on weekends, disable weekends
          var d = new Date(val + "T09:00:00.000Z");
          if (d.getDay() != 6 && d.getDay() != 0) return val;
        } else {
          return val;
        }
      }
    },

    submitPtoChange() {

      var hasChanges = false;
      hasChanges = this.hasChanges();
      /*
      for (var i = 0; i < this.inputs.length; i++) {
          if (this.inputs[i]['new_day'] || this.inputs[i]['type']) {
            hasChanges = true;
            break; 
          }  
      }*/

      if (!hasChanges && this.deletes.length <= 0) {
        this.dialog2_title = "Are you sure?";
        this.dialog2_text = "You did not make any changes. Do you want to leave this page?";
        this.dialog2_redBtn = "Leave";
        this.dialog2_redBtn_type = "leave";
        this.dialog2_blueBtn = "Cancel";
        this.dialog2_blueBtn_type = "cancel";
        this.dialog2 = true;        
        return;
      }

      if (this.validateChanges() == false) {  
        return;
       }

/*
      let debug = true;
      this.dialog2_title = "Testing...";
      this.dialog2_text = "Testing....";
      this.dialog2_blueBtn = "Cancel";
      this.dialog2_blueBtn_type = "cancel";
      this.dialog2 = true;        
      if (debug)
        return false;
*/
      
      axios
          .post("./remote-apis/ptoSubmit.php", {
            formData: JSON.stringify(this.inputs),
            work_weekends: JSON.stringify(this.work_weekends),
            deletes: JSON.stringify(this.deletes),
            action: JSON.stringify("edit"),           
          })
          .then((res) => {
            if (res.data.response == "OK") {
              this.dialog2_title = "Thank you!";
              this.dialog2_text =
                "Your request has been sent.";
              this.dialog2_blueBtn_type = "success";
              this.dialog2 = true; 
            } else if (res.data.response == "FAILED") {
              this.dialog2_title = "Alert!";
              if (res.data.message)
                this.dialog2_text = res.data.message;
              else
                this.dialog2_text =
                  "Cannot process your request. Please try again.";
              this.dialog2_blueBtn_type = "error";
              this.dialog2 = true;
            } else if (res.data.response == "DEBUG") {
              this.dialog2_title = "Debug title";
              if (res.data.message)
                this.dialog2_text = res.data.message;
              else
                this.dialog2_text = "Debug text";
              this.dialog2_blueBtn_type = "debug";
              this.dialog2 = true;   
            } else {
              var message = "Cannot process your request. Please try again later.";
              if (res.data.message) 
                message = res.data.message;
              this.dialog2_blueBtn_type = "error";
              this.dialog2_text = message;
              this.dialog2 = true;  
            }  
          })
          .catch((error) => {
            window.console.log(error);
          });

      return true;
    },

    validateChanges() {

      var input_date = null;    
      var actualDates = [];
      var actualDays = [];
      //var totalDays = { holiday: 0, personal: 0, sick: 0, vacation: 0, jury_duty: 0, bereavement: 0, covid: 0 };
      var totalDays = pto_func.getPtoCats("object_zero");
      var increment = 0.5;
      var type_name = "";
      var formatted_input_date = "";
      var input_date_taken = false;
      var tmp_index = -1;
      var req_yr = null;
      var cur_fiscal_year_str = pto_func.get_fiscal_year("cur_str");
      var next_fiscal_year_str = pto_func.get_fiscal_year("next_str");
      var prev_fiscal_year_str = pto_func.get_fiscal_year("prev_str");
      var fy_str = "";
      var prenatal_start = null;
      var prenatal_end = null ;
      var display_type_name = "" ;
      var pto_unit = "" ;
/*          
      var debug = true;
      this.dialog2_title = "Test!";
      this.dialog2_text = "Testing 2 .... " + input_date;
      this.dialog2_type = "test";
      this.dialog2 = true; 
      if (debug == true)
        return false;         
*/

      //this.inputs is the date object of entered requests
      // loop each request:
      for (var index = 0; index < this.inputs.length; index++) {

        // blank input fields
        if (this.inputs[index]["new_day"].trim().length <= 0 && this.inputs[index]["type"].trim().length <= 0) 
          continue;

        if (this.inputs[index]["new_day"].trim().length <= 0 || this.inputs[index]["type"].trim().length <= 0) {
              this.dialog2_blueBtn_type = "error";
              this.dialog2_text = `All fields are required. To undo, click on Edit button again.`;
              this.dialog2 = true;
              return false;
        }

        input_date = new Date(this.inputs[index]["new_day"].trim() + "T09:00:00.000Z");
        input_date_taken = false;
        tmp_index = -1;
        //increment = 0.5;
        //if (this.inputs[index]["full_partial"].toLowerCase() == "full") increment = 1;
        increment = pto_func.full_partial_to_num(this.inputs[index]["full_partial"]);

        req_yr = pto_func.get_fiscal_year("date_long", input_date);		
        if (req_yr == this.cur_fiscal_year)
          fy_str = " for " + cur_fiscal_year_str;
        else if (req_yr == this.next_fiscal_year)
          fy_str = " for " + next_fiscal_year_str;
        else if (req_yr == this.prev_fiscal_year)
          fy_str = " for " + prev_fiscal_year_str;
        

        type_name = this.inputs[index]["type"];

        if (type_name.toLowerCase() == "covid" && increment > 0.5) {
          this.dialog2_text = "Please select AM or PM for COVID Vaccine/Booster.";
          this.dialog2_blueBtn_type = "error";
          this.dialog2 = true;
          return false;
        }         

        if (type_name.toLowerCase() == "covid_sick" && increment < 1) {
          this.dialog2_text = "Please select Full Day for COVID Sick Days.";
          this.dialog2_blueBtn_type = "error";
          this.dialog2 = true;
          return false;
        }         

        if (type_name.toLowerCase() == "prenatal" ) {

          this.dialog2_text = "";

          prenatal_start = moment(this.inputs[index]["prenatal_start"], ['h:m a', 'H:m', 'HH:mm:ss']) ;
          prenatal_end = moment(this.inputs[index]["prenatal_end"], ['h:m a', 'H:m', 'HH:mm:ss']) ;

          if (prenatal_end.isBefore(prenatal_start) || prenatal_end.isSame(prenatal_start)) {
            this.dialog2_text = "Prenatal Care Start Time must be earlier than the End Time.";
          }       

          // prenatal care minimum increments of one hour
          if ((prenatal_end.diff(prenatal_start, 'minutes') % 60) > 0) {
            this.dialog2_text = "Prenatal Care must be scheduled in minimum increments of one hour.";
          }
  
          increment = prenatal_end.diff(prenatal_start, 'hours', true);

          if (this.dialog2_text.length > 0) {
            this.dialog2_blueBtn_type = "error";
            this.dialog2 = true;
            return false;
          }
        }         

        formatted_input_date = pto_func.formatDate(input_date);

        if (type_name.toLowerCase() == "prenatal") {
          if (pto_func.is_input_date_taken(formatted_input_date, this.inputs[index]["prenatal_start"] + "_" + this.inputs[index]["prenatal_end"], this.pto_container, req_yr))
              input_date_taken = true;
        } else {
          if (pto_func.is_input_date_taken(formatted_input_date, this.inputs[index]["full_partial"], this.pto_container, req_yr))
              input_date_taken = true;
        }

        if (type_name.toLowerCase() == "prenatal") {
            pto_unit = "hour" ;
            display_type_name = "Prenatal Care" ;
            fy_str = "" ;
        } else {
            pto_unit = "day" ;
            display_type_name = type_name.replace("_", " ") ;
        }
        
          
       // if (pto_func.is_input_date_taken(formatted_input_date, this.inputs[index]["full_partial"], this.pto_container, req_yr)) {
       if (input_date_taken) {
              this.dialog2_blueBtn_type = "error";
              this.dialog2_text = `Selected date: ` + formatted_input_date + ` (` + this.inputs[index]["full_partial"] + `) was taken or scheduled already.`;
              this.dialog2 = true;
            return false;
        }

        // check if exceed limits
        totalDays[req_yr][type_name] += increment;
        if (totalDays[req_yr][type_name] > this.pto_container[req_yr][type_name]['remain_total'] && type_name.toLowerCase() != "covid_sick" && type_name.toLowerCase() != "bereavement" && type_name.toLowerCase() != "jury_duty") {
              this.dialog2_blueBtn_type = "error";
              if (this.pto_container[req_yr][type_name]['remain_total'] <= 0) {
                this.dialog2_text = "You have no  " + type_name.replace("_", " ") + " day remaining" + fy_str + ". ";
              } else {
                this.dialog2_text = `Do not schedule more than ` + this.pto[req_yr][type_name]['remain'] + ` ` + display_type_name + 
                ` ` + pto_unit + `(s)` + fy_str + `.`;
              }
              this.dialog2 = true;
              return false;
            }

            // check if the same date was selected previously (when add more was used)
            tmp_index = actualDates.map(Number).indexOf(+input_date); // same input date from previous
            if (tmp_index >= 0) {
              if (
                pto_func.dayHasConflict(
                  actualDays[tmp_index],
                  this.inputs[index]["full_partial"]
                )
              )
                input_date_taken = true;
            }

            if (input_date_taken == true) {             
              this.dialog2_blueBtn_type = "error";
              this.dialog2_text =
                "Selected date " +
                formatted_input_date +
                " " +
                (this.inputs[index]["full_partial"].toLowerCase() == "full"
                  ? "Full Day"
                  : this.inputs[index]["full_partial"]) +
                " was taken or scheduled already.";
              this.dialog2 = true;  
              return false;
            }

            actualDates.push(input_date);
            actualDays.push(this.inputs[index]["full_partial"]);            

      }
      //window.console.log(actualDates);
      //window.console.log(actualDays);
      return true;
    },

    hasChanges() {

      let edit_el = null;
      let delete_el = null;
      var isEditActive = false;
      var isDeleteActive = false;

      for (var i = 0; i < this.inputs.length; i++) {
        /*
        if (this.inputs[i]["new_day"].trim().length > 0 || this.inputs[i]["type"].trim().length > 0) {
          showConfirm = true;
          break;
        }*/
        edit_el = document.getElementById(this.inputs[i]["sched_id"] + "_edit");
        delete_el = document.getElementById(this.inputs[i]["sched_id"] + "_delete");
        isEditActive = edit_el.classList.contains("pto_btn_active");
        isDeleteActive = delete_el.classList.contains("pto_btn_active");
        // Edit or Delete button was clicked
        if (isEditActive == true || isDeleteActive == true) {
          return true;
        }
      }
      return false;
    },

    closeChangeDialog() {
      if (this.hasChanges() == true) {
        this.dialog2_title = "You have unsaved changes",
        this.dialog2_text = "You are about to leave this page without saving. All changes will be lost. Do you want to leave without saving?";
        this.dialog2_redBtn = "Leave";
        this.dialog2_redBtn_type = "leave";
        this.dialog2_blueBtn = "Cancel";
        this.dialog2_blueBtn_type = "cancel";
        this.dialog2 = true;
        return false;
      } else {
        this.dialog = false;
        window.location.reload();
      }
    },

    // During transition_rough in early Sept, force calendar to popup Aug 1.
    // Since date_picker_max should be Aug 31, this could block loading Sept calendar
    populate_default(k) { 

      if (this.inputs[k]['new_day'])  // new day has a value, do nothing
        return;

      if (this.site_status == "transition_rough" && !this.inputs[k]['new_day']) {
          var default_end_year = pto_func.get_default("default_end_year");
          this.inputs[k]['new_day'] = default_end_year + "-08-01";
      } else if (this.inputs[k]['sched_id']) {
        let sched_id = this.inputs[k]['sched_id'].split("_");
        let sched_date = sched_id[1].split("/");
        this.inputs[k]['new_day'] = sched_date[2] + "-" + sched_date[0] + "-" + sched_date[1];
      }
      return;      
    },

  },
};
</script>

<style scoped>

.ptoBtn:focus::before {
  opacity: 0 !important;
}

.list-item-date {
  padding-right: 80px;
}

.prompt {
  font-weight: 500;
}

.dateBlockMobile {
  width: 98%;
  margin-left: 2px;
}

.dateBlock {
  width: 75%;
  margin-left: 80px;
}

.v-subheader {
  font-size: 16px;
  color: #000;
}

.v-list-item {
  min-height: 50px;
}

.v-list-item__content {
  padding-top: 0px !important;
}

.ptoClose .v-btn__content .v-icon {
  color: #fff !important;
}

.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 32px;
  min-width: 100px;
}

.dk_brown {
  background-color: #4f2c1d;
}

.row {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.v-label,
span.label {
  font-weight: normal !important;
}

.icon-circle-gray {
  background: #bbb;
  padding: 2px;
  border-radius: 50%;
}

.icon-circle-green {
  color: green;
}

.icon-white {
  color: #fff;
  font-size: 1.1em;
}

.custom1cols {
  width: 100%;
  max-width: 100%;
  flex-basis: 100%;
  padding-left: 0px;
  padding-bottom: 0px;
}

.changeCustom1cols {
  width: 90%;
  max-width: 90%;
  flex-basis: 90%;
  padding-left: 0px;
  padding-bottom: 0px;
}

.custom3cols {
  width: 25%;
  max-width: 25%;
  flex-basis: 25%;
  padding-left: 5px;
  padding-bottom: 0px;
}

.custom4cols {
  width: 75%;
  max-width: 75%;
  flex-basis: 75%;
  padding-bottom: 0px;
}

.radio {
  display: inline-block;
}

.radio /deep/ label {
  font-weight: normal !important;
}

.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}

.custom9cols {
  width: 75%;
  max-width: 75%;
  flex-basis: 75%;
  padding-bottom: 0px;
}

.pto_btn_active {
  background-color: #7a6855 !important;
  color: #ffffff;
}

.pto_align_center {
  padding-top: 28px !important;
}

.v-application p.inst {
  margin-top: 1px;
  font-style: italic;
  font-size: 13px;
  width: 90%;
  padding-bottom: 0;
  margin-bottom: 0;
}

.inst a {
  text-decoration-color: #ffb500 !important;
  text-decoration-thickness: 2px !important;
  text-decoration: underline;
}

.dt-picker /deep/ .v-btn {
  border-radius: 28px !important;
}

.form_padding {
  padding-top: 25px;
  padding-bottom: 25px;
}

.container {
  width: 92% !important;
}

.fy_header {
  color: #4f2c1d !important;
  font-weight: bold;
  font-size: 20px;
  border-bottom: solid #ffb500 1px;
}

.note {
  margin: 4px;
  font-style: italic;
  font-size: 13px;
  width: 90%;
}

</style>